import {
  Button,
  Grid,
  Snackbar,
  Alert,
  Tooltip,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import { Box } from "@mui/system";
import axios from "axios";
import { default as React, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import dayjs from "dayjs";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";

const ReportProcess = () => {
  const userName = useSelector((state) => state.branch.userName);

  const [reportHasError, setReportHasError] = useState(false);
  const [reportDateValidDateError, setReportDateValidDateError] =
    useState(false);

  const [titleValue, setTitleValue] = useState("");

  const [areaName, setAreaName] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [selectedAreaRows, setSelectedAreaRows] = useState([]);
  const [selectedAreaName, setSelectedAreaName] = useState([]);

  const [zoneName, setZoneName] = useState([]);
  const [selectedZoneRows, setSelectedZoneRows] = useState([]);
  const [selectedZoneName, setSelectedZoneName] = useState([]);

  const [branchName, setBranchName] = useState([]);
  const [selectedBranchRows, setSelectedBranchRows] = useState([]);
  const [selectedBranchName, setSelectedBranchName] = useState([]);
  const [reportTypeList, setReportTypeList] = useState([]);
  const [dropDownValue, setDropDownValue] = useState("");

  const [branchCluster,setBranchCluster] = useState();

  const [originalUserAreaZoneBranchMap, setOriginalUserAreaZoneBranchMap] =
    useState([]);

  const columnsArea = [
    {
      field: "area_name",
      headerName: "Area",
      headerAlign: "center",
      align: "left",
      flex: 350,
      type: "string",
      editable: false,
      value: areaName,
    },
  ];

  const columnsZone = [
    {
      field: "zone_name",
      headerName: "Zone",
      headerAlign: "center",
      align: "left",
      flex: 350,
      type: "string",
      editable: false,
      value: zoneName,
    },
  ];

  const columnsBranch = [
    {
      field: "branch_name",
      headerName: "Branch",
      headerAlign: "center",
      align: "left",
      flex: 350,
      type: "string",
      editable: false,
      value: branchName,
    },
  ];

  const [errorMessage, setErrorMessage] = useState("");

  const [datarowsArea, setDatarowsArea] = useState([]);
  const [datarowsZone, setDatarowsZone] = useState([]);
  const [datarowsBranch, setDatarowsBranch] = useState([]);

  const [columnsAreaData, setAreaColumns] = useState(columnsArea);
  const [columnsZoneData, setZoneColumns] = useState(columnsZone);
  const [columnsBranchData, setBranchColumns] = useState(columnsBranch);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  const dispatch = useDispatch();
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);
  //shortcut key
  const downloadRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "reportProcess",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    let refList = { downloadRef: downloadRef };
    if (event.ctrlKey) {
      if (charCode === "i") {
        setReportDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setReportDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setReportDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "reportProcess",
          })
        );
      }
    }
  };

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["ReportProcess Request Date Back Count"] &&
        new Date(
          paramValues["ReportProcess Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["ReportProcess Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.reportRequestDate &&
        fieldAccessMap.reportRequestDateBackCount
          ? Number(
              paramValues["ReportProcess Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["ReportProcess Request Date Future Count"] &&
        new Date(
          paramValues["ReportProcess Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["ReportProcess Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.reportRequestDate &&
        fieldAccessMap.reportRequestDateFutureCount
          ? Number(
              paramValues["ReportProcess Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }
  const SendAreaData = async () => {
    try {
      setLoading(true)
      const userAreas = await axios.post("/api/getBranchCluster", {
        apiCode: "BRANCH_CLUSTER_API",
        createdBy: userName,
        requestBody: {
          username: btoa(userName),
        },
      });
      if (userAreas.data.message === "Success") {
        setLoading(false)
        //set to state
        setBranchCluster(userAreas.data.branch_details)
        const userAreaZoneBranchMap = [...userAreas.data.branch_details];
        setOriginalUserAreaZoneBranchMap(userAreaZoneBranchMap);
        const areaData = userAreaZoneBranchMap.map((data) => {
          return data.area_name;
        });
        const recordWithOutDuplicateAreaData = [...new Set(areaData)];
        setAreaData(recordWithOutDuplicateAreaData);
        const areaRows = recordWithOutDuplicateAreaData.map((data) => {
          return {
            id: data,
            area_name: data,
          };
        });
        setDatarowsArea(areaRows);
      } else {
        setLoading(false)
        setErrorMessage(userAreas.data.error_msg);
        openAlertHandler();
      }
    } catch (exception) {
      setLoading(false)
      if (exception.code === "ERR_NETWORK") {
        setErrorMessage(exception.message);
      }
      openAlertHandler();
    }
  };

  useEffect(() => {
    SendAreaData();
    getReportTypes();
  }, []);
  const getReportTypes = async () => {
    try {
      const nachLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD012",
      });
      const reportTypeMap = nachLovValues.data["Report Type"].map((type) => {
        return {
          key: type.lovOrder,
          value: type.lovValues,
          text: type.lovValues,
        };
      });
      setReportTypeList(reportTypeMap);
    } catch (e) {}
  };
  const checkedData = () => {
    let storedData = {
      area: [],
      zone: [],
      branch: [],
    };
    if (selectedAreaRows.length !== 0) {
      const selectedAreaName = selectedAreaRows.map((data) => {
        return data.area_name;
      });
      storedData["area"] = selectedAreaName;
      setSelectedAreaName(selectedAreaName);
    }
    if (selectedZoneRows.length !== 0) {
      const selectedZoneName = selectedZoneRows.map((data) => {
        return data.zone_name;
      });
      storedData["zone"] = selectedZoneName;
      setSelectedZoneName(selectedZoneName);
    }
    if (selectedBranchRows.length !== 0) {
      const selectedBranchName = selectedBranchRows.map((data) => {
        return data.branch_name;
      });
      storedData["branch"] = selectedBranchName;
      setSelectedBranchName(selectedBranchName);
    }
    return storedData;
  };

  const SendZoneData = async () => {
    let updatedAreaData = checkedData();

      
      //removed api call
      if (branchCluster!==[]) {
        const zoneName = branchCluster.filter((data) => {
            return updatedAreaData["area"].includes(data.area_name);
          });
        //
        const zoneData = zoneName.map((data) => {
          return data.zone_name;
        });
        const recordWithOutDuplicateZone = [...new Set(zoneData)];
        setZoneName(recordWithOutDuplicateZone);
        const zoneRows = recordWithOutDuplicateZone.map((data) => {
          return {
            id: data,
            zone_name: data,
          };
        });
        setDatarowsZone(zoneRows);
      }
  };

  const zoneRelatedData = useMemo(() => {
    SendZoneData();
  }, [selectedAreaRows]);

  const SendBranchData = async () => {
    let updatedZoneData = checkedData();

    //removed api call
    if (branchCluster!==[]) {
      const branchName = branchCluster.filter((data) => {
              return updatedZoneData["zone"].includes(data.zone_name);
            });
      //
        const branchData = branchName.map((data) => {
          return data.branch_name;
        });
        const recordWithOutDuplicateBranch = [...new Set(branchData)];
        setBranchName(recordWithOutDuplicateBranch);
        const branchRows = recordWithOutDuplicateBranch.map((data) => {
          return {
            id: data,
            branch_name: data,
          };
        });
        setDatarowsBranch(branchRows);
      }
  };

  const branchRelatedData = useMemo(() => {
    SendBranchData();
  }, [selectedZoneRows]);

  const selectBranchData = async () => {
    let updatedBranchData = checkedData();
    return updatedBranchData["branch"];
  };

  const relatedData = useMemo(() => {
    selectBranchData();
  }, [selectedBranchRows]);

  const handleChange = (event) => {
    let value = event.target.value;
    setDropDownValue(value);
    setReportHasError(false);
    if (value === "LPS") {
      setTitleValue("Loan Processing Statement");
    } else if (value === "Demand") {
      setTitleValue("Demand Report");
    } else if (value === "Non Performing Loan") {
      setTitleValue("Non Performing Loan Report");
    }
  };

  const handleTitle = () => {
    if (dropDownValue === "") {
      setTitleValue("Report Process");
    }
  };

  useEffect(() => {
    handleTitle();
  }, []);

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

  const [reportDate, setReportDate] = useState(currentDate);
  const [reportDateValid, setReportDateValid] = useState(true);
  const [reportDateHasError, setReportDateHasError] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const validateDownload = () => {
    setTimeout(() => {
      checkedData();
    }, 0);

    const isReportValid =
      dropDownValue !== "" &&
      dropDownValue !== undefined &&
      dropDownValue !== null
        ? true
        : false;

    if (isReportValid) {
      if (!reportDateValidDateError && !reportDateHasError) {
        setReportHasError(false);
        if (selectedAreaRows.length === 0) {
          setMessage("Area is not been selected.");
          setAlertType("error");
          openAlertHandler();
        } else if (selectedZoneRows.length === 0) {
          setMessage("Zone is not been selected.");
          setAlertType("error");
          openAlertHandler();
        } else if (selectedBranchRows.length === 0) {
          setMessage("Branch is not been selected.");
          setAlertType("error");
          openAlertHandler();
        } else {
          setTimeout(() => {
            setReportDateValid(
              reportDate !== undefined &&
                reportDate !== "" &&
                reportDate !== null
            );

            setReportDateHasError(!reportDateValid);
            handleDownload();
          }, 0);
        }
      }
    } else {
      setReportHasError(true);
    }
  };

  const getFilteredSelectedAreaZoneBranchCodes = () => {
    const selectedAreaCodes = [...originalUserAreaZoneBranchMap]
      .filter((data) => selectedAreaName.includes(data.area_name))
      .map((data) => data.area_code);
    const selectedZoneCodes = [...originalUserAreaZoneBranchMap]
      .filter((data) => selectedZoneName.includes(data.zone_name))
      .map((data) => data.zone_code);
    const selectedBranchCodes = [...originalUserAreaZoneBranchMap]
      .filter((data) => selectedBranchName.includes(data.branch_name))
      .map((data) => data.branch_code);
    return {
      areaCodes: [...new Set(selectedAreaCodes)],
      zoneCodes: [...new Set(selectedZoneCodes)],
      branchCodes: [...new Set(selectedBranchCodes)],
    };
  };

  const handleDownload = () => {
    setLoading(true)
    setLoadingMsg("Downloading Report...")
    if (dropDownValue === "LPS") {
      try {
        const selectedData = getFilteredSelectedAreaZoneBranchCodes();
        axios
          .post(
            "lps/lpsReportGeneration",
            {
              areaList: selectedData.areaCodes,
              zoneList: selectedData.zoneCodes,
              branchList: selectedData.branchCodes,
              reportDate: dayjs(reportDate).format("MM/DD/YYYY"),
            },
            {
              method: "POST",
              responseType: "blob",
            }
          )
          .then((response) => {
            setLoading(false)
            setLoadingMsg("")
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `LPS_` + dayjs(reportDate).format("MM/DD/YYYY") + `.xls`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setMessage(
                "Loan Processing Statement File Downloaded Successfully."
              );
              setAlertType("success");
              openAlertHandler();
            } else {
              setMessage("No data to get downloaded for selected details.");
              setAlertType("error");
              openAlertHandler();
            }
          });
      } catch (error) {
        setLoading(false)
        setLoadingMsg("")
        setMessage("Loan Processing Statement File Download Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    } else if (dropDownValue === "Demand") {
      try {
        const selectedData = getFilteredSelectedAreaZoneBranchCodes();
        axios
          .post(
            "nplDemand/demandReportGeneration",
            {
              areaList: selectedData.areaCodes,
              zoneList: selectedData.zoneCodes,
              branchList: selectedData.branchCodes,
              reportDate: dayjs(reportDate).format("MM/DD/YYYY"),
            },
            {
              method: "POST",
              responseType: "blob",
            }
          )
          .then((response) => {
            setLoading(false)
            setLoadingMsg("")
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `Demand_` + dayjs(reportDate).format("MM/DD/YYYY") + `.xls`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setMessage("Demand Statement File Downloaded Successfully.");
              setAlertType("success");
              openAlertHandler();
            } else {
              setMessage("No data to get downloaded for selected details.");
              setAlertType("info");
              openAlertHandler();
            }
          });
      } catch (error) {
        setLoading(false)
        setLoadingMsg("")
        setMessage("Demand Statement File Download Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    } else if (dropDownValue === "Non Performing Loan") {
      try {
        const selectedData = getFilteredSelectedAreaZoneBranchCodes();
        axios
          .post(
            "nplDemand/nplReportGeneration",
            {
              areaList: selectedData.areaCodes,
              zoneList: selectedData.zoneCodes,
              branchList: selectedData.branchCodes,
              reportDate: dayjs(reportDate).format("MM/DD/YYYY"),
            },
            {
              method: "POST",
              responseType: "blob",
            }
          )
          .then((response) => {
            setLoading(false)
            setLoadingMsg("")
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",

                `NPL_` + dayjs(reportDate).format("MM/DD/YYYY") + `.xls`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setMessage("Non Performing Loan File Downloaded Successfully.");
              setAlertType("success");
              openAlertHandler();
            }
            if (response.status === 206) {
              setMessage("No data to get downloaded for selected details.");
              setAlertType("info");
              openAlertHandler();
            }
          });
      } catch (error) {
        setLoading(false)
        setLoadingMsg("")
        setMessage("Non Performing Loan File Download Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    }
  };

  return (
    <>
    {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord-lps"
            title={titleValue}
            initialOpen={true}
            // sx={{ margin: "8px !important" }}
          >
            <Box id="accord-box" component="form" validate="true">
              <Grid item container spacing={1}>
                <Grid id="grid-container" item xs={12} md={4}>
                  <CustomDropDown
                    label="Report Type"
                    variant="standard"
                    value={dropDownValue}
                    required={true}
                    dropDownValue={reportTypeList}
                    onChange={handleChange}
                  />
                  {reportHasError && (
                    <p className="error">Please Select Report Type</p>
                  )}
                </Grid>
                <Grid id="grid-container" item xs={12} md={4}>
                  <CustomDateField
                    label="Report Date"
                    variant="standard"
                    disabled={false}
                    required={true}
                    value={reportDate}
                    minDate={new Date().setDate(
                      new Date().getDate() - minDateFromValue
                    )}
                    maxDate={new Date().setDate(
                      new Date().getDate() + maxDateFromValue
                    )}
                    onChange={(newValue) => {
                      setReportDate(
                        new Date(dayjs(newValue).format("MM/DD/YYYY"))
                      );
                      setReportDateValid(
                        newValue !== undefined &&
                          newValue !== "" &&
                          newValue !== null
                      );
                      setReportDateHasError(
                        newValue
                          ? false
                          : true &&
                              !(
                                reportDate !== undefined &&
                                reportDate !== "" &&
                                reportDate !== null
                              )
                      );
                      if (
                        newValue !== null &&
                        newValue !== undefined &&
                        newValue !== ""
                      ) {
                        const invalidValue =
                          new Date(newValue).toDateString() !==
                            "Invalid Date" &&
                          new Date(newValue).toLocaleDateString().slice(-4) >=
                            "1970" &&
                          new Date(newValue).toLocaleDateString().slice(-4) <=
                            "2055"
                            ? false
                            : true;
                        setReportDateValidDateError(
                          invalidValue ? true : false
                        );
                        const newDateValue = `${new Date(
                          newValue
                        ).getFullYear()}/${
                          new Date(newValue).getMonth() + 1 > 9
                            ? new Date(newValue).getMonth() + 1
                            : "0" + new Date(newValue).getMonth() + 1
                        }/${
                          new Date(newValue).getDate() > 9
                            ? new Date(newValue).getDate()
                            : "0" + new Date(newValue).getDate()
                        }`;
                        const maxValue = new Date().setDate(
                          new Date().getDate() + maxDateFromValue
                        );
                        const maxDateValue = `${new Date(
                          maxValue
                        ).getFullYear()}/${
                          new Date(maxValue).getMonth() + 1 > 9
                            ? new Date(maxValue).getMonth() + 1
                            : "0" + new Date(maxValue).getMonth() + 1
                        }/${
                          new Date(maxValue).getDate() > 9
                            ? new Date(maxValue).getDate()
                            : "0" + new Date(maxValue).getDate()
                        }`;

                        const minValue = new Date().setDate(
                          new Date().getDate() - minDateFromValue
                        );
                        const minDateValue = `${new Date(
                          minValue
                        ).getFullYear()}/${
                          new Date(minValue).getMonth() + 1 > 9
                            ? new Date(minValue).getMonth() + 1
                            : "0" + new Date(minValue).getMonth() + 1
                        }/${
                          new Date(minValue).getDate() > 9
                            ? new Date(minValue).getDate()
                            : "0" + new Date(minValue).getDate()
                        }`;
                        const specialAccessMaxFlag =
                          newDateValue <= maxDateValue;
                        const specialAccessMinFlag =
                          newDateValue >= minDateValue;
                        if (specialAccessMaxFlag && specialAccessMinFlag) {
                          setReportDateHasError(false);
                          setReportDateValidDateError(false);
                        } else {
                          setReportDateHasError(false);
                          setReportDateValidDateError(true);
                        }
                      } else {
                        setReportDateValidDateError(false);
                        setReportDateHasError(true);
                      }
                    }}
                  ></CustomDateField>
                  {reportDateHasError && (
                    <p className="error">Please Select Report Date</p>
                  )}
                  {reportDateValidDateError && (
                    <p className="error">Please Enter Valid Date</p>
                  )}
                </Grid>
              </Grid>
              <Box
                sx={{
                  marginTop: "12px",
                  marginBottom: "8px",
                  display: "flex",
                  gap: "2rem",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Ctrl+J" placement="top">
                  <Button
                    variant="contained"
                    component="label"
                    onClick={validateDownload}
                    ref={downloadRef}
                  >
                    Download
                  </Button>
                </Tooltip>
              </Box>
              <Snackbar
                open={alert}
                autoHideDuration={3000}
                anchorOrigin={{ vertical, horizontal }}
                onClose={closeAlertHandler}
              >
                <Alert
                  onClose={closeAlertHandler}
                  severity={alertType}
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  {message}
                </Alert>
              </Snackbar>
            </Box>
          </AccordianContainer>
          <AccordianContainer id="accord" title="Details" initialOpen={true}>
            <>
              <div
                style={{
                  direction: "rtl",
                  marginBottom: "4px",
                }}
              ></div>
              <Grid
                container
                spacing={4}
                sx={{
                  width: "calc(100% - 8px)",
                  margin: "unset",
                }}
              >
                <CustomDataGrid
                  noDataMessage="No Data"
                  rows={datarowsArea}
                  columns={columnsAreaData}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  gridHeight={305}
                  gridWidth={window.innerWidth / 3.25}
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" || param.key === "E") &&
                      param.preventDefault();
                  }}
                  checkboxSelection
                  onSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedAreaRows = datarowsArea.filter((row) =>
                      selectedIDs.has(row.id)
                    );
                    setSelectedAreaRows(selectedAreaRows);
                  }}
                  onCellClick={zoneRelatedData}
                />
                <CustomDataGrid
                  noDataMessage="No Data"
                  rows={datarowsZone}
                  columns={columnsZoneData}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  gridHeight={305}
                  gridWidth={window.innerWidth / 3.25}
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" || param.key === "E") &&
                      param.preventDefault();
                  }}
                  checkboxSelection
                  onSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedZoneRows = datarowsZone.filter((row) =>
                      selectedIDs.has(row.id)
                    );
                    setSelectedZoneRows(selectedZoneRows);
                  }}
                  onCellClick={branchRelatedData}
                />
                <CustomDataGrid
                  noDataMessage="No Data"
                  rows={datarowsBranch}
                  columns={columnsBranchData}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  gridHeight={305}
                  gridWidth={window.innerWidth / 3.25}
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" || param.key === "E") &&
                      param.preventDefault();
                  }}
                  checkboxSelection
                  onSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedBranchRows = datarowsBranch.filter((row) =>
                      selectedIDs.has(row.id)
                    );
                    setSelectedBranchRows(selectedBranchRows);
                  }}
                  onCellClick={relatedData}
                />
              </Grid>
            </>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            ></Box>
          </AccordianContainer>
        </Grid>
      </div>
      <StlapFooter />
    </>
  );
};

export default ReportProcess;
